export default {
  namespaced: true,
  state: {
    panelId: null,
    prevPanelId: null,
    isHidden: false
  },

  getters: {
    panelId: state => state.panelId,
    prevPanelId: state => state.prevPanelId,
    isOpen: state => Boolean(state.panelId),
    isHidden: state => state.isHidden
  },

  mutations: {
    PANEL_ID(state, value) {
      state.prevPanelId = state.panelId;
      state.panelId = value;
    },

    HIDDEN(state, value) {
      state.isHidden = value
    }
  },

  actions: {
    updatePanelId({commit, dispatch, rootGetters}, data){
      //clear search when switching sidebar item/panel
      if(rootGetters['search/query']) dispatch('search/clear', true, {root: true})
      // the sidebar animates opening/closing, hence the timeout
      if(rootGetters['routing/routeName'] === 'area' && rootGetters['viewport/isDesktop']){
        setTimeout(() => dispatch('recalculateRoomLayout', null, {root:true}), 125);
      }

      commit('PANEL_ID', data);
    },
    open({dispatch}, value) {
      if(typeof value !== 'string') console.warn("sidebar panel id must be a string");
      else dispatch('updatePanelId', value);
    },
    openPrev: ({dispatch, getters}) => dispatch('updatePanelId', getters.prevPanelId),
    close: ({dispatch}) => dispatch('updatePanelId', null),
    hide: ({commit}) => commit('HIDDEN', true),
    show: ({commit}) => commit('HIDDEN', false)
  }
};
